import React from "react";
import NotFound from "../../Assets/404error.svg";
import Button from "@material-ui/core/Button";
import { NavLink } from "react-router-dom";
import "./PageNotFound.styles.scss";

const PageNotFound = () => (
  <div className="error_container">
    <div id="error_image_container">
      <img src={NotFound} alt="PageNotFound" />
    </div>
    <div id="error_desc_container" style={{ lineHeight: "1rem" }}>
      <p
        style={{
          textAlign: "center",
          fontWeight: "bolder",
          fontSize: "1.5rem",
        }}
      >
        Sorry, page not found!
      </p>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
        }}
      >
        The page you requested could not be found
      </p>
    </div>
    <div id="error_redirect_console">
      <Button variant="contained" color="primary">
        <NavLink style={{ color: "white" }} to="/console">
          Return to Dashboard
        </NavLink>
      </Button>
    </div>
  </div>
);

export default PageNotFound;
